import { HandleType, makeIsAllowed } from '@kanda-libs/ks-component-ts';

export const CONFIRM_ACCOUNT_VALIDATION = {
  required: {
    value: true,
    message: 'You must confirm the above bank account is in your name',
  },
};

export const ERROR_PROPS = {
  label: 'You must provide the amount of time you have held this account for',
  className: 'text-style-h text-red-200 -mt-4 mb-6',
};

export const ACCOUNT_NUMBER_VALIDATION = {
  minLength: {
    value: 1,
    message: 'Account Number requires minimum length of 1',
  },
  pattern: {
    value: /^[0-9]{8}$/,
    message:
      'Account Number must be 8 digits. If your account number is less than 8 digits long please add a 0 at the start.',
  },
  required: { value: true, message: 'Account Number is required.' },
};

export const PROPS = {
  confirmAccount: {
    name: 'confirm_account',
    handle: 'checkbox' as HandleType,
    fieldText:
      'I confirm that the account is in my name, and that I am an authorised signatory who is able to authorise this Direct Debits from this account',
  },
  accountYearsOwned: {
    name: 'bank_account.years_owned',
    label: '',
    placeholder: 'Years',
    isAllowed: makeIsAllowed(0, 100),
  },
  accountMonthsOwned: {
    name: 'bank_account.months_owned',
    label: '',
    placeholder: 'Months',
    isAllowed: makeIsAllowed(0, 11),
  },
  iva: {
    name: 'bankruptcy_iva',
    handle: 'checkbox' as HandleType,
    fieldText:
      'I confirm I have not had an IVA or been bankrupt in the last 5 years',
    validation: {
      required: {
        value: true,
        message: 'You must select an option',
      },
    },
  },
};
